import { TurnstileMode } from '@shared/public/models';

export interface AppVariables {
  WHITELABEL_BRAND: AppVariablesBrand;
  WHITELABEL_HOSTNAME: string;
  WHITELABEL_LOGO: string;
  WHITELABEL_LINK: string;
  WHITELABEL_SMS_CHARS: string;
  WHITELABEL_SMS_NON_ANSI_CHARS: string;
  ACCOUNT_DELETING_DELAY: string;
  FREE_PLAN_LOCATION_LIMIT: number;
  MAX_SAVED_REPLIES: number;
  FULL_CALENDAR_KEY: string;
  UNPAID_PARTY_LIFETIME: number;
  SERVICE_FEE: number;
  APP_VERSION: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_VAPID_KEY: string;
  FIREBASE_SERVICE_WORKER_PATH: string;
  CLOUDFLARE_TURNSTILE_SITE_KEY: string;
  CLOUDFLARE_TURNSTILE_MODE: TurnstileMode;
  CLOUDFLARE_TURNSTILE_ALLOW_UNAVAILABLE_BYPASS: boolean;
  SIGNUP_TURNSTILE_MODE: TurnstileMode;
}

export enum AppVariablesBrand {
  TablesReady = 'TablesReady',
}
